import { gql } from '@apollo/client';

export const CalendarJobFields = gql`
  fragment CalendarJobFields on Job {
    id
    name
    startDate
    endDate
    recurring
    notes
    jobNumber
    createdAt
    updatedAt
    jobType {
      id
      name
    }
    trade {
      id
      name
    }
    calendarResource {
      id
      name
    }
    warehouse {
      id
      name
    }
    jobStatuses {
      id
      name
      iconCode
      iconExtraClasses
    }
    jobAttributeValues {
      id
      value
      jobAttribute {
        id
        label
        displayOnCard
        adminOnly
        fieldType
        specialBehavior
        specialBehaviorOptions
      }
    }
    propertyAddress {
      id
      address
      jobNumber
      plan
      builder {
        id
        name
      }
      subdivision {
        id
        name
      }
    }
    createdBy {
      id
      email
      firstName
      lastName
    }
    updatedBy {
      id
      email
      firstName
      lastName
    }
  }
`;
